import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const ColumnSearchFieldContainer = styled.div<{ focused: boolean }>`
    padding: 8px;
    border-bottom: 1px solid ${colorsPalettes.carbon[50]};

    .input-container {
        transition:
            box-shadow 0.2s ease-in-out,
            border-color 0.2s ease-in-out;
        cursor: pointer;

        &:hover {
            border-color: ${colorsPalettes.midnight[50]};
            box-shadow: 0px 3px 5px rgba(42, 62, 82, 0.12);
        }

        ${(p) =>
            p.focused &&
            css`
                border-color: ${colorsPalettes.midnight[50]};
                box-shadow: 0px 3px 5px rgba(42, 62, 82, 0.12);
            `}
    }
`;
